module.exports = __webpack_public_path__ + "static/img/img-main-award@2x.9194ade.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/img-main-award@2x.png
// module id = 1GiK
// module chunks = 18